import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 네고스탁에서")
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 조합지분 구매 내용을 확인 하셨나요?")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!

  return (_openBlock(), _createBlock(_component_ag_content, null, {
    default: _withCtx(() => [
      _createVNode(_component_ag_box, {
        mb: "16px",
        mt: "16px",
        direction: "column",
        dp: "flex",
        height: "100%",
        "justify-content": "center",
        "align-items": "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_img, {
            mt: "24px",
            src: "/assets/svg/checkStroke.svg"
          }),
          _createVNode(_component_ag_text, {
            "padding-top": "32px",
            "text-align": 'center',
            color: 'gray2',
            typography: 'main16r'
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _hoisted_2,
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}